// Material
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
// Logic
import { getUserDisplayName, useUser } from '$logic/users'
// Common
import { PageWithAppBar } from '$common/page-with-app-bar'
import { RoomProfileHeader } from '$common/room-profile-header'
import { SettingsSection } from '$common/settings-section'
import { UserStatus } from '$common/user-status'
// Helpers
import { closeUserProfile } from '$logic/router'
import { showChatWithUserMenu } from '$comp/modals/menus/chat-with-user-menu'
// Components
import { UserProfileInfo } from './user-profile-info'
import { UserProfileActions } from './user-profile-actions'
import { UserProfileNotification } from './user-profile-notification'
import { UserAvatar } from '$common/avatar'
import { AvatarSize } from '$common/avatar/avatar-base/types'
import { OpenStorySource } from '$logic/story/analytics'

const ShadowedBox = styled(Box)`
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
`

interface Props {
  userId: string
}

export function UserProfile({ userId }: Props) {
  const { user } = useUser(userId)
  // TODO: ADD USER_STATUS IN SECONDARY_TEXT IN ROOM_PROFILE_HEADER
  // TODO: CHECK THE PATTERN OF USER_STATUS AND USER_AVATAR WHICH THEMSELVES HANDLE SHOWING BASED ON AN IDENTIFIER
  // <UserStatus userId={userId} />

  return (
    <PageWithAppBar
      appBar={
        <RoomProfileHeader
          avatarElement={
            <UserAvatar
              size={AvatarSize.XL}
              userId={userId}
              withStory
              source={OpenStorySource.ROOM_PROFILE}
            />
          }
          avatarSrc={''}
          primaryText={getUserDisplayName(user)}
          onBack={closeUserProfile}
          secondaryText={<UserStatus userId={userId} textColor="neutral600" />}
          hasDeleted={user?.deletedAt}
          onMenu={() => showChatWithUserMenu({ userId })}
          avatarBackground={''}
        />
      }
    >
      {user && (
        <SettingsSection>
          <>
            <UserProfileInfo user={user} />
            <UserProfileNotification userId={userId} />
          </>
        </SettingsSection>
      )}

      <ShadowedBox>
        <UserProfileActions userId={userId} />
      </ShadowedBox>
    </PageWithAppBar>
  )
}
